import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import FilterButton from '../../_common/FilterButton/FilterButton';
import classes from './refills.module.scss';
import InputField from '../../_common/Form/TextFields/InputField';
import Select from '../../_common/Form/Selects/Select/Select';
import { specOptions } from '../../../utils/data/data';
import accountHelpers from '../../../utils/accountHelpers';
import { useQuery } from '../../../utils/hooks/useQuery';
import utils from '../../../utils/utils';
import { changeMenuPath } from '../../../store/actions/menu';
import { getRefillsRequest } from '../../../store/actions/refills';
import { getSelectRepListRequest } from '../../../store/actions/users';
import RefilesTable from './RefillsTable/RefilesTable';
import Loader from '../../_common/Loader/Loader';

const typeData = [
  {
    title: 'Ok to Refill',
    key: 'status',
    value: 'Refill',
  },
  {
    title: 'Refill Request',
    key: 'status',
    value: 'Renew',
  },
];

const header = ['Process On', 'Physician', 'Patient', 'Medication', 'RX Number', 'Last Faxed', 'Fax'];

let timeout;

function Refills() {
  const dispatch = useDispatch();
  const { refillsList, refillTotalPage, requestStatus } = useSelector((store) => store.refills);
  const { selectRepList, pageCount, currentPage } = useSelector((store) => store.users);

  const { query, setQuery, queryToStringify } = useQuery();
  const { pathname } = useLocation();

  const [requestData, setRequestData] = useState(
    {
      status: query.status || 'Refill',
      textSearch: query.textSearch || '',
      rep: query.rep || '',
      spec: query.spec || '',
      page: query.page || 1,
      limit: query.limit || 15,
      userId: accountHelpers.getUser().id,
    },
  );

  const {
    page, limit, status, textSearch, spec,
  } = requestData;

  useEffect(() => {
    const newQuery = utils.deleteEmptyKeys({ ...requestData });
    delete newQuery.userId;

    dispatch(changeMenuPath('Refills', `${pathname}${queryToStringify(newQuery)}`));
    setQuery(newQuery);
  }, [requestData]);

  useEffect(() => {
    dispatch(getSelectRepListRequest({ limit: 20, role: 'Rep' }));

    const newQuery = utils.deleteEmptyKeys({ ...requestData });

    dispatch(getRefillsRequest(newQuery));
  }, []);

  const onTypeClick = (key, value) => {
    setRequestData((prev) => ({ ...prev, [key]: value, page: 1 }));

    const newQuery = utils.deleteEmptyKeys({ ...requestData, [key]: value, page: 1 });

    dispatch(getRefillsRequest(newQuery));
  };

  const onSearchChange = (value) => {
    setRequestData((prev) => ({ ...prev, textSearch: value, page: 1 }));

    const newQuery = utils.deleteEmptyKeys({ ...requestData, textSearch: value, page: 1 });

    clearTimeout(timeout);

    timeout = setTimeout(() => {
      dispatch(getRefillsRequest(newQuery));
    }, 500);
  };

  const nextOptionListRequest = async (pageRep) => {
    await dispatch(getSelectRepListRequest({ page: pageRep, limit: 20, role: 'Rep' }));
  };

  const onChangeFilter = (key, value) => {
    setRequestData((prev) => ({ ...prev, [key]: value, page: 1 }));

    const newQuery = utils.deleteEmptyKeys({ ...requestData, [key]: value, page: 1 });

    dispatch(getRefillsRequest(newQuery));
  };

  const onChangePageData = async (path, count) => {
    const newQuery = utils.deleteEmptyKeys({ ...requestData });

    if (path === 'limit') {
      setRequestData((prev) => ({ ...prev, [path]: count, page: 1 }));

      newQuery[path] = count;
      newQuery.page = 1;

      dispatch(getRefillsRequest(newQuery));
    } else {
      setRequestData((prev) => ({ ...prev, [path]: count }));

      newQuery[path] = count;
      dispatch(getRefillsRequest(newQuery));
    }
  };

  return (
    <div className={classes.wrapper}>
      <div className={classes.header}>
        <div className={classes.filter_button}>
          <FilterButton
            onClick={onTypeClick}
            label="Type"
            activeValue={status}
            buttonsData={typeData}
            disableActiveButton
          />
        </div>

        <div className={classes.header_left}>
          <div className={classes.input_wrapper}>
            <div className={classes.input_filter_wrapper}>
              <InputField
                label="Search by text"
                value={textSearch}
                onChange={onSearchChange}
              />
            </div>

            <div className={classes.input_filter_wrapper}>
              <Select
                label="Rep"
                nextOptionListRequest={nextOptionListRequest}
                options={selectRepList}
                totalPage={pageCount}
                currentPage={currentPage}
                limit={20}
                currentOption={requestData.rep}
                onChange={(option) => onChangeFilter('rep', option)}
                optionPathname="name"
              />
            </div>

            <div className={classes.input_filter_wrapper}>
              <Select
                label="All specializations"
                options={specOptions}
                currentOption={spec}
                onChange={(option) => onChangeFilter('spec', option)}
              />
            </div>
          </div>

          {/* <div className={classes.button_wrapper}> */}
          {/*  <Button */}
          {/*    className={classes.updateButton} */}
          {/*    title="Assign to Me" */}
          {/*    type="submit" */}
          {/*    reverseColor */}
          {/*    onClick={() => {}} */}
          {/*  /> */}
          {/* </div> */}
        </div>
      </div>

      {requestStatus !== 'success'
        ? <div className={classes.loader}><Loader /></div>
        : (
          <div className={classes.table_wrapper}>
            <RefilesTable
              header={header}
              onChange={onChangePageData}
              page={+page - 1}
              limit={+limit}
              totalPage={+refillTotalPage}
              data={refillsList}
              className={classes.table_tr}
              classFax={classes.table_fax}
              status={status}
            />
          </div>
        )}
    </div>
  );
}

export default Refills;
